/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSpaltenSummaryDto } from '../../models/lexplus-spalten-summary-dto';

export interface KundendokumentSpaltenauswahlControllerGetCustomFelderForStandortV1$Params {
  standortId: number;
}

export function kundendokumentSpaltenauswahlControllerGetCustomFelderForStandortV1(http: HttpClient, rootUrl: string, params: KundendokumentSpaltenauswahlControllerGetCustomFelderForStandortV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSpaltenSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, kundendokumentSpaltenauswahlControllerGetCustomFelderForStandortV1.PATH, 'get');
  if (params) {
    rb.path('standortId', params.standortId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSpaltenSummaryDto>;
    })
  );
}

kundendokumentSpaltenauswahlControllerGetCustomFelderForStandortV1.PATH = '/v1/kundendokument-spaltenauswahl/custom-felder-for-standort/{standortId}';
